import { show_layout_modal } from "../global";

export class EditTable {

  constructor(allowNew, path_prefix, path_suffix = '', tableSelector = 'table#edit-table') {
    this.allowNew = allowNew;
    this.path_prefix = path_prefix;
    this.path_suffix = path_suffix;
    this.tableSelector = tableSelector;
  }

  getTableData() {
    const table = $(this.tableSelector);
    const paramKeys = table.data('edit-table-params');
    if (!paramKeys) {
      return {};
    }

    const result = {};
    paramKeys.split(/[ ,]+/).forEach(key => {
      const val = table.data(key);
      if (val !== undefined) {
        const snakeKey = key.replace(/-/g, '_').replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`);
        result[snakeKey] = val;
      }
    });
    return result;
  }

  init() {
    console.debug(`EditTable init on ${this.tableSelector}`);
    this.setupEditButtons();
    this.setupCancelButtons();
    this.setupSaveButtons();
    this.setupDestroyButtons();
  }

  setupEditButtons() {
    $(`${this.tableSelector} .edit-button`).each( (index, element) => {
      this.setupSingleEditButton($(element));
    });
  }

  setupCancelButtons() {
    $(this.tableSelector).on('click', '.cancel-button', (event) => {
      event.preventDefault();
      var editItemRow = $(event.currentTarget).parents('tr.edit-item-row');
      var itemId = editItemRow.data('item-id');
      $(`${this.tableSelector} tr#show-item-${itemId}`).removeClass('d-none');
      $(`${this.tableSelector} tr#edit-item-${itemId}`).addClass('d-none');
    });
  }

  setupDestroyButtons() {
    $(this.tableSelector).on('click', '.destroy-button', (event) => {
      event.preventDefault();
      var showItemRow = $(event.currentTarget).parents('tr.show-item-row');
      var itemId = showItemRow.data('item-id');
      $.ajax({
        method: "DELETE",
        url: `${this.path_prefix}/${itemId}${this.path_suffix}`,
        dataType: 'json',
        success: () => {
          console.log("delete success");
          $(`${this.tableSelector} tr#show-item-${itemId}`).remove();
          $(`${this.tableSelector} tr#edit-item-${itemId}`).remove();
            },
        error: (data) => {
	        var respBody = data.responseJSON;
          console.error(`err: ${respBody.error}, code: ${data.status}`);
          show_layout_modal(respBody.error);
        }
      });
    });
  }

  setupSaveButtons() {
    var meta = $('meta[name=csrf-token]');
    var csrfToken = meta.attr('content');
    $(this.tableSelector).on('click', '.save-button', (event) => {
      event.preventDefault();
      var editItemRow = $(event.currentTarget).parents('tr.edit-item-row');
      var itemId = editItemRow.data('item-id');
      var params = this.getTableData();
      $(`${this.tableSelector} tr#edit-item-${itemId} .item-param`).each( (index, elt) => {
        var val;
        if ($(elt).attr('type') === 'checkbox') {
          val = $(elt).is(':checked');
        } else {
          val = $(elt).val();
        }
        params[$(elt).attr('name')] = val;
      });

      $.ajax({
        method: "PUT",
        url: `${this.path_prefix}/${itemId}${this.path_suffix}`,
        headers: { "X-CSRF-Token": csrfToken },
        contentType: "application/json",
        data: JSON.stringify(params),
        success: (data, textStatus, xhr) => {
          console.debug("update success");
          var showItemRow  = $(`${this.tableSelector} tr#show-item-${itemId}`)
          var editItemRow = $(`${this.tableSelector} tr#edit-item-${itemId}`);
          var newShowItemRow = $($.parseHTML(data));
          showItemRow.replaceWith(newShowItemRow);

          itemId = newShowItemRow.filter('tr').data("item-id");
          editItemRow.attr("id", `edit-item-${itemId}`);
          editItemRow.data('item-id', itemId);
          editItemRow.attr("data-item-id", itemId);

          this.setupSingleEditButton(newShowItemRow.find('.edit-button'));
          newShowItemRow.removeClass('d-none');
          $(`${this.tableSelector} tr#edit-item-${itemId}`).addClass('d-none');
          $(`${this.tableSelector} tr#edit-item-${itemId}`).removeClass('new-item');

          if (this.allowNew === true && $(`${this.tableSelector} .new-item`).length == 0) {
            this.prependNewRow();
          }
        },
        error: (data, textStatus, xhr) => {
          var respBody = data.responseJSON || {};
          var errorMsg = respBody.error || "An unknown error occurred";
          console.error(`err: ${errorMsg}, code: ${data.status}`);
          show_layout_modal(errorMsg);
        }
      });
    });
  }

  setupSingleEditButton(btnElt) {
    btnElt.on('click', (event) => {
      event.preventDefault();
      var itemId = $(event.currentTarget).data('item-id');
      $(`${this.tableSelector} tr#show-item-${itemId}`).addClass('d-none');
      $(`${this.tableSelector} tr#edit-item-${itemId}`).removeClass('d-none');
      $(`${this.tableSelector} tr#edit-item-${itemId} #name`).trigger('focus');
      $(`${this.tableSelector} tr#edit-item-${itemId} #name`).trigger('select');
    });
  }

  prependNewRow() {
    var params = this.getTableData();
    $.get(`${this.path_prefix}/new${this.path_suffix}`, params, (data) => {
      var newShowItemRow = $($.parseHTML(data));
      $(`${this.tableSelector} tr.show-item-row:first`).before(newShowItemRow);
      this.setupSingleEditButton(newShowItemRow.find('a.edit-button'));

      if (typeof this.onNewRow === 'function') {
        this.onNewRow(newShowItemRow);
      }
    }).fail( (data, textStatus, xhr) => {
      var respBody = data.responseJSON;
      console.error(`err: ${respBody.error}, code: ${data.status}`);
      show_layout_modal(respBody.error);
    });
  }

  setOnNewRowCallback(callback) {
    this.onNewRow = callback;
  }
}
